var _defs, _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "643a377d10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93 227 L 282 227 L 282 346.703125 L 93 346.703125 Z M 93 227 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0160fe",
    d: "M 93.742188 28.199219 L 0 87.921875 L 93.742188 147.644531 L 187.5 87.921875 Z M 93.742188 28.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0160fe",
    d: "M 281.25 28.199219 L 187.5 87.925781 L 281.25 147.65625 L 375 87.925781 Z M 281.25 28.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0160fe",
    d: "M 0 207.378906 L 93.742188 267.097656 L 187.5 207.378906 L 93.742188 147.65625 Z M 0 207.378906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0160fe",
    d: "M 281.25 147.65625 L 187.5 207.378906 L 281.25 267.113281 L 375 207.378906 Z M 281.25 147.65625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#643a377d10)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0160fe",
    d: "M 93.75 287.136719 L 187.515625 346.859375 L 281.25 287.136719 L 187.515625 227.417969 Z M 93.75 287.136719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.1f4a7719ac40f7385e2e66bd7744da06.svg";
export { ForwardRef as ReactComponent };